import { SortMethods } from "@views/hooks/useCollectionSorting"

export const mapSortMethodToName = (sortMethod?: SortMethods) => {
  switch (sortMethod) {
    case SortMethods.ByBestSelling:
      return "Best Selling"
    case SortMethods.ByFeatured:
      return "Featured"
    case SortMethods.ByPrice:
      return "Price Low to High"
    case SortMethods.ByPriceReversed:
      return "Price High to Low"
    case SortMethods.ByRecent:
      return "Newest"
  }
}
